// TopBar Login components
//

const topBar = {};

topBar.bindEvents = (clicked, el, selector) => {
  clicked.addEventListener("click", e => {
    e.preventDefault();
    topBar.toggleMenu(el, selector);
  });
};

topBar.toggleMenu = (el, selector) => {
  const isOpen = el.classList.contains(selector);
  const dropdown = document.getElementById('user-menu-dropdown');
  
  if (isOpen) {
    el.classList.remove(selector);
    el.setAttribute('aria-expanded', 'false');
    if (dropdown) {
      dropdown.classList.add('TopBar__Container__Navigation__Item__Popup--hide');
    }
  } else {
    el.classList.add(selector);
    el.setAttribute('aria-expanded', 'true');
    if (dropdown) {
      dropdown.classList.remove('TopBar__Container__Navigation__Item__Popup--hide');
      // Focus first menu item with proper accessibility
      const firstMenuItem = dropdown.querySelector('[role="menuitem"]');
      if (firstMenuItem) {
        // Set all menu items to be tabbable (tabindex 0)
        const allMenuItems = dropdown.querySelectorAll('[role="menuitem"]');
        allMenuItems.forEach(item => item.setAttribute('tabindex', '0'));
        
        // Create a live region to announce the first item's instructions
        const announcement = firstMenuItem.getAttribute('aria-label');
        const liveRegion = document.createElement('div');
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('aria-atomic', 'true');
        liveRegion.className = 'sr-only';
        liveRegion.style.position = 'absolute';
        liveRegion.style.left = '-10000px';
        liveRegion.style.width = '1px';
        liveRegion.style.height = '1px';
        liveRegion.style.overflow = 'hidden';
        document.body.appendChild(liveRegion);
        
        setTimeout(() => {
          firstMenuItem.focus();
          // Announce the instructions via live region
          liveRegion.textContent = announcement;
          
          // Clean up the live region after announcement
          setTimeout(() => {
            if (liveRegion.parentNode) {
              liveRegion.parentNode.removeChild(liveRegion);
            }
          }, 2000);
        }, 100);
      }
    }
  }
};

topBar.handleKeyboardNavigation = (e, menuItems, currentIndex) => {
  let newIndex = currentIndex;
  
  switch (e.key) {
    case 'ArrowDown':
      e.preventDefault();
      newIndex = (currentIndex + 1) % menuItems.length;
      break;
    case 'ArrowUp':
      e.preventDefault();
      newIndex = currentIndex === 0 ? menuItems.length - 1 : currentIndex - 1;
      break;
    case 'Home':
      e.preventDefault();
      newIndex = 0;
      break;
    case 'End':
      e.preventDefault();
      newIndex = menuItems.length - 1;
      break;
    case 'Escape':
      e.preventDefault();
      const menuButton = document.querySelector('.TopBar__Container__Navigation__Item__Link--login');
      if (menuButton) {
        topBar.toggleMenu(menuButton, 'TopBar__Container__Navigation__Item__Link--open');
        menuButton.focus();
      }
      return;
    case 'Enter':
    case ' ':
      e.preventDefault();
      menuItems[currentIndex].click();
      return;
    default:
      return;
  }
  
  // Update focus (keep all items tabbable for TAB navigation)
  menuItems[newIndex].focus();
};

topBar.init = () => {
  const elements = document.querySelectorAll(
    ".TopBar__Container__Navigation__Item__Link"
  );

  if (elements) {
    elements.forEach(el => {
      const parent = el.parentNode;

      if (parent.children && parent.children.length === 2) {
        // Mouse click events
        topBar.bindEvents(
          el,
          el,
          "TopBar__Container__Navigation__Item__Link--open"
        );

        // Keyboard events for menu button
        el.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            topBar.toggleMenu(el, 'TopBar__Container__Navigation__Item__Link--open');
          }
        });

        // Click outside to close
        document
          .querySelector(".TopBar__Container__Navigation__Item__Popup__Overlay")
          .addEventListener("click", () => {
            el.classList.remove(
              "TopBar__Container__Navigation__Item__Link--open"
            );
            el.setAttribute('aria-expanded', 'false');
            const dropdown = document.getElementById('user-menu-dropdown');
            if (dropdown) {
              dropdown.classList.add('TopBar__Container__Navigation__Item__Popup--hide');
            }
          });

        // Setup menu item keyboard navigation
        const dropdown = document.getElementById('user-menu-dropdown');
        if (dropdown) {
          const menuItems = dropdown.querySelectorAll('[role="menuitem"]');
          
          menuItems.forEach((item, index) => {
            item.addEventListener('keydown', (e) => {
              topBar.handleKeyboardNavigation(e, menuItems, index);
            });
          });
        }
      }
    });
  }

  const toggleNavi = document.querySelector(".TopBar__Container__Toggle");
  const topBarEl = document.querySelector(".TopBar__Placeholder");
  if (toggleNavi !== null && topBarEl !== null) {
    topBar.bindEvents(toggleNavi, topBarEl, "TopBar__Placeholder__Open");
  }
};

window.topBar = topBar;
